import * as YUP from 'yup';

declare module 'yup' {
    interface StringSchema {
        integer(): StringSchema;
        letters(): StringSchema;
        startWith0(): StringSchema;
    }
}

YUP.addMethod<YUP.StringSchema>(YUP.string, 'integer', function () {
    return this.matches(/^\d+$/, 'Enter numbers/integers only.');
});

YUP.addMethod<YUP.StringSchema>(YUP.string, 'letters', function letters() {
    return this.matches(/^[A-Za-z]+$/, 'Enter letters only.');
});

YUP.addMethod<YUP.StringSchema>(YUP.string, 'startWith0', function () {
    return this.matches(/^0/, 'Should start with 0.');
});

export const loginFormValidation = YUP.object().shape({
    email: YUP.string()
        .email('Invalid email address.')
        .required('Enter email address.'),
    password: YUP.string()
        .required('Enter password.'),
});

export const forgotPasswordFormValidation = YUP.object().shape({
    email: YUP.string()
        .email('Invalid email address.')
        .required('Enter email address.'),
});

export const resetPasswordFormValidation = YUP.object().shape({
    otp: YUP.string()
        .min(6, 'OTP is too short.')
        .max(6, 'OTP is too long.')
        .required('Enter OTP.'),
    password: YUP.string()
        .min(6, 'At least 6 characters, password too short.')
        .required('Enter password.'),
    confirm_password: YUP.string()
        .oneOf([YUP.ref('password'), null], 'Passwords must match.')
});

export const registerFormValidation = YUP.object().shape({
    first_name: YUP.string()
        .min(2, 'First name too short.')
        .max(20, 'First name too long.')
        .required('Enter first name.'),
    last_name: YUP.string()
        .min(2, 'Last name too short.')
        .max(20, 'Last name too long.')
        .letters()
        .required('Enter last name.'),
    email: YUP.string()
        .email('Invalid email address.')
        .required('Enter email address.'),
    password: YUP.string()
        .min(5, 'Password too short.')
        .required('Enter password.'),
    phone: YUP.string()
        .integer()
        .startWith0()
        .min(10, 'Phone too short.')
        .max(10, 'Phone too long.')
        .required('Enter phone number.'),
    gender: YUP.string()
        .required('Select gender.'),
    role: YUP.string()
        .required('Select role.')
});

export const addCompanyFormValidation = YUP.object().shape({
    name: YUP.string()
        .min(3, 'Company name too short.')
        // .letters()
        .required('Enter company name'),
    email: YUP.string()
        .email('Invalid email address.'),
    // .required('Enter email address.'),
    phone: YUP.string()
        .integer()
        .startWith0()
        .min(10, 'Phone too short.')
        .max(10, 'Phone too long.')
        .required('Enter phone number.'),
    // address: YUP.string()
    //     .required('Enter your business address.')
});

export const addVehicleFormValidation = YUP.object().shape({
    make: YUP.string()
        .min(2, 'Vehicle make too short.')
        .required('Enter vehicle name.'),
    model: YUP.string()
        .min(2, 'Vehicle model too short.')
        .required('Enter vehicle model.'),
    year: YUP.string()
        .min(4, 'Year too short.')
        .max(4, 'Year too long.')
        .required('Enter vehicle year.'),
    transmission: YUP.string()
        .required('Select vehicle transmission.'),
    fuel_type: YUP.string()
        .required('Select fuel type.'),
    color: YUP.string()
        .required('Enter vehicle color.'),
    registration_number: YUP.string()
        .required('Enter registration number.'),
    fleet_type: YUP.string()
        .required('Select fleet type required.')
});

export const addCustomerFormValidation = YUP.object().shape({
    first_name: YUP.string()
        .min(2, 'Customer name too short.')
        .required('Enter customer name.'),
    last_name: YUP.string()
        .min(3, 'Customer name too short.')
        .letters()
        .required('Enter customer name.'),
    email: YUP.string()
        .email('Invalid email address.')
        .required('Enter email address.'),
    phone: YUP.string()
        .integer()
        .startWith0()
        .min(10, 'Phone too short.')
        .max(10, 'Phone too long.')
        .required('Enter phone number.'),
    // address: YUP.string()
    //     .required('Enter your business address.')
});

export const addDeliveryFormValidation = YUP.object().shape({
    customer_id: YUP.string()
        .required('Select a customer.'),
    // date: YUP.string()
    //     .required('Pick delivery date.'),
    // time: YUP.string()
    //     .required('Select delivery time.'),
    fleet: YUP.string()
        .required('Select fleet size.'),
    payment_method: YUP.string()
        .required('Select payment method.'),
    loaders: YUP.string()
        .required('Select number of loaders')
});

export const updateUserFormValidation = YUP.object().shape({
    phone: YUP.string()
        .integer()
        .min(10, 'Phone number too short.')
        .max(10, 'Phone number too long.')
        .required('Enter phone number.'),
});

export const updateBankingFormValidation = YUP.object().shape({
    account_number: YUP.string()
        .integer()
        .min(10, 'Account number too short.')
        .max(12, 'Account number too long.')
        .required('Enter account number.'),
    bank_name: YUP.string()
        .required('Select bank.'),
    note: YUP.string()
        .min(10, 'Note number too short.')
        .max(200, 'Note number too long.')
        .required('Enter note.'),
    terms_of_service: YUP.string()
        .min(10, 'Terms of service too short.')
        .max(200, 'Terms of service too long.')
        .required('Enter terms of service.'),
});

export const updatePasswordFormValidation = YUP.object().shape({
    password: YUP.string()
        .min(6, 'Password must be at least 6 characters long.')
        .required('Enter password.'),
    confirm_password: YUP.string()
        .oneOf([YUP.ref('password'), null], 'Passwords must match')
});

export const companyRequestRegistrationFormValidation = YUP.object().shape({
    email: YUP.string()
        .email('Invalid email address.')
        .required('Enter email address.'),
    phone: YUP.string()
        .integer()
        .startWith0()
        .min(10, 'Phone too short.')
        .min(10, 'Phone too long.')
        .required('Enter phone number.'),
    company_name: YUP.string()
        .min(2, 'Company name too short.')
        .required('Enter company name.'),
});

export const companyRequestWebsiteFormValidation = YUP.object().shape({
    email: YUP.string()
        .email('Invalid email address.')
        .required('Enter email address.'),
    phone: YUP.string()
        .integer()
        .startWith0()
        .min(10, 'Phone too short.')
        .min(10, 'Phone too long.')
        .required('Enter phone number.'),
    domain_name: YUP.string()
        .min(6, 'domain name too short.')
        .required('Enter domain name.'),
    amount: YUP.number()
        .required('Enter amount name.'),
    template_id: YUP.string()
        .required('Select template.'),
});

export const donationFormValidation = YUP.object().shape({
    amount: YUP.number()
        .integer()
        .required('Enter amount.'),
});

export const fleetFormValidation = YUP.object().shape({
    fleet_size: YUP.string()
        .required('Fleet size is required.'),
    fleet_amount: YUP.number()
        .default(0)
        .integer()
        .required('Fleet amount is required.'),
    per_km: YUP.number()
        .default(0)
        .integer()
        .required('Per km is required.'),
    loader_amount: YUP.number()
        .default(0)
        .integer()
        .required('Loader amount is required.'),
    description: YUP.string()
        .required('Description is required.'),
});

export const addServiceFormValidation = YUP.object().shape({
    name: YUP.string()
        .required('Name is required.'),
    description: YUP.string()
        .min(80)
        .required('Description is required.'),
});

export const editServiceFormValidation = YUP.object().shape({
    name: YUP.string()
        .required('Name is required.'),
    description: YUP.string()
        .min(80)
        .required('Description is required.'),
    is_active: YUP.boolean()
        .required('IsActive status is required.'),
});

export const headerSectionFormValidation = YUP.object().shape({
    company_id: YUP.string()
        .required('Company ID is required.'),
    title: YUP.string()
        .required('Title is required.'),
    description: YUP.string()
        .required('Description is required.'),
});

export const parcelDeliveryFromValidation = YUP.object().shape({
    // company_id: YUP.string()
    //     .required('Company ID is required.'),
    first_name: YUP.string()
        .required('Enter first name.'),
    last_name: YUP.string()
        .required('Enter last name.'),
    id_number: YUP.string()
        .min(13, 'ID number is too short.')
        .max(13, 'ID number is too long.'),
    email: YUP.string()
        .required('Enter email address.')
        .email('Email address is invalid.'),
    phone: YUP.string()
        .integer()
        .startWith0()
        .min(10, 'Phone number too short.')
        .max(10, 'Phone number too long.')
        .required('Enter phone number.'),
    pickup_address: YUP.string()
        .required('Select pickup address.'),
    dropoff_address: YUP.string()
        .required('Select dropoff address.'),
    status: YUP.string()
        .required('Select parcel delivery status.'),
    amount: YUP.string()
        .required('Enter the amount.'),
    payment_status: YUP.string()
        .required('Select payment status.')
});

export const editParcelDeliveryFromValidation = YUP.object().shape({
    company_id: YUP.string()
        .required('Company ID is required.'),
    parcel_id: YUP.string()
        .required('Parcel ID is required.'),
    first_name: YUP.string()
        .required('Enter first name.'),
    last_name: YUP.string()
        .required('Enter last name.'),
    id_number: YUP.string()
        .min(13, 'ID number is too short.')
        .max(13, 'ID number is too long.'),
    email: YUP.string()
        .required('Enter email address.')
        .email('Email address is invalid.'),
    phone: YUP.string()
        .integer()
        .startWith0()
        .min(10, 'Phone number too short.')
        .max(10, 'Phone number too long.')
        .required('Enter phone number.'),
    pickup_address: YUP.string()
        .required('Select pickup address.'),
    dropoff_address: YUP.string()
        .required('Select dropoff address.'),
    status: YUP.string()
        .required('Select parcel delivery status.'),
    amount: YUP.string()
        .required('Enter the amount.'),
    payment_status: YUP.string()
        .required('Select payment status.')
});